module.exports = __webpack_public_path__ + "img/search2.6404ea7a.svg";